import { render, staticRenderFns } from "./EnergyLawInformation.vue?vue&type=template&id=47bde0a8&scoped=true&"
import script from "./EnergyLawInformation.vue?vue&type=script&lang=js&"
export * from "./EnergyLawInformation.vue?vue&type=script&lang=js&"
import style0 from "./EnergyLawInformation.vue?vue&type=style&index=0&id=47bde0a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bde0a8",
  null
  
)

export default component.exports